import { LoadingIndicatorSpinner } from "./Loading.styles.js";

export default function Loading() {
  return <LoadingIndicatorSpinner id="loading-indicator-spinner" />;
}
